module.exports = __webpack_public_path__ + "img/git-hub-link.972fff2a.svg";